import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-300/20">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-12 md:py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-xl font-heading font-bold text-foreground-50">天天影院</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              天天影院拥有最新电影大全、动作片在线、喜剧片免费看、科幻片高清播放及经典电影全集，极速播放不卡顿，海量片库免费高清在线看。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-400 hover:text-primary-500 hover:bg-background-200 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-400 hover:text-primary-500 hover:bg-background-200 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-200/50 text-foreground-400 hover:text-primary-500 hover:bg-background-200 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-100 mb-4">电影分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-100 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  动作片
                </Link>
              </li>
              <li>
                <Link to="/category/scifi" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  科幻片
                </Link>
              </li>
              <li>
                <Link to="/category/classic" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  经典电影
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-foreground-100 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500"></i>
                </div>
                contact@tiantiancinema.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-primary-500"></i>
                </div>
                400-888-6688
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-500">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-pin-line text-primary-500"></i>
                </div>
                北京市朝阳区建国路88号
              </li>
            </ul>
            <div className="mt-4">
              <p className="text-xs text-foreground-600">客服时间：每天 9:00 - 22:00</p>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {currentYear} 天天影院. 保留所有权利.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-600 hover:text-foreground-400 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}